import UnifiedCalendar from "@/components/UnifiedCalendar";
import { useAuth } from "@/context/AuthContext";
import { CalendarDays } from "lucide-react";

export default function MyCalendar() {
  const { user } = useAuth();
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10" data-testid="my-calendar-page">
      <p className="text-xs tracking-[0.2em] uppercase font-semibold text-[#D98E73] mb-2 flex items-center gap-2"><CalendarDays size={14} /> Your Schedule</p>
      <h1 className="font-serif text-3xl sm:text-4xl text-[#1A242B] mb-2">My calendar</h1>
      <p className="text-[#4A5D6B] mb-8">Your upcoming appointments, registered events and classes, and saved broadcasts — all in one place{user?.name ? `, ${user.name.split(" ")[0]}` : ""}.</p>
      <UnifiedCalendar scope="me" />
    </div>
  );
}
